import { Pipe } from "@angular/core";

@Pipe({name: 'truncate'})
export class TruncatePipe {
    transform(value:string, limit:number, trail:string = '...')
    {
        var trimmed = value.substring(0, limit);
        return value.length > limit ? trimmed + trail : trimmed;
    }
}


// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/collections.pipe.ts